import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';

type SettingsButtonProps = {
  isOpen: boolean;
};

const Layout = styled.div`
  min-height: 100vh;

  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  /* min-height: 92vh; */

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Wrapper = styled.div`
  flex: 2;
`;

const NavMobile = styled.div`
  display: flex;
  justify-content: space-between;

  padding: 1.2rem;
`;

const SettingsButton = styled(Button)<SettingsButtonProps>`
  z-index: 10000;

  color: ${({ isOpen }) => (isOpen ? pickColor('white') : pickColor('blackLight'))};
`;

export { Layout, Container, Wrapper, NavMobile, SettingsButton };
